<template>
  <v-app v-if="isAdmin">
    <v-container class="mt-5">
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="users"
            :loading="loading"
            :class="isdarkmode ? 'v-data-table-dark' : 'v-data-table-light'"
            item-key="id"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Hledat uživatele"
                class="mx-4"
              ></v-text-field>
            </template>
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="selectUser(item)" color="orange" rounded small>
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <span>Zobrazit detaily</span>
              </v-tooltip>
            </template>
            <template v-slot:loading>
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="800">
        <v-card>
          
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2">mdi-account-circle</v-icon>
            <span class="text-h5">Uživatel: {{ selectedUser && selectedUser.displayName }}</span>
            <v-spacer></v-spacer>
             <v-btn
        color="grey darken-1"
        text
        @click="dialog = false"
      >
        Zavřít
      </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-6">
            <v-row>
              <v-col cols="12" md="6">
                <div class="mb-4">
                  <span class="font-weight-semibold">E-mail:</span>
                  <span class="ml-2">{{ selectedUser && selectedUser.email }}</span>
                </div>
                <div>
                  <span class="font-weight-semibold">Role:</span>
                  <span class="ml-2">{{ selectedUser && selectedUser.status }}</span>
                </div>
              </v-col>
             
            </v-row>

            <v-divider class="my-4"></v-divider>

            <h4 class="mb-4">
              <v-icon class="mr-2">mdi-file-document-multiple</v-icon>
              Vypracované formuláře:
            </h4>
            <v-list v-if="selectedUser && selectedUser.noticeboards.length > 0" class="dense">
              <v-list-item v-for="noticeboard in selectedUser.noticeboards" :key="noticeboard.id">
                <v-list-item-icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span class="font-weight-medium">{{ noticeboard.name }}</span>
                </v-list-item-content>
                 <v-list-item-action>
                    <v-chip
                      :color="noticeboard.isfinal === null ? 'green' : (noticeboard.isfinal ? 'green' : 'red')"
                      class="ml-2"
                    >
                      <v-icon v-if="noticeboard.isfinal === null">mdi-lock-open-variant</v-icon>
                      <v-icon v-else-if="noticeboard.isfinal">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                      {{
                        noticeboard.isfinal === null
                          ? 'Odemčený'
                          : noticeboard.isfinal
                          ? 'Odeslaný'
                          : 'Neodeslaný'
                      }}
                    </v-chip>
                  </v-list-item-action>
     <template v-slot:append>
  <template v-if="noticeboard.isfinal === 1">
    <Unlock
    :noticeboard-name="noticeboard.name"
    :user-uid="selectedUser.uid"
    :noticeboard-id="noticeboard.id"
    @unlocked="handleUnlock"
    ></Unlock>
  </template>
</template>

              </v-list-item>
            </v-list>
            <p v-else class="text-muted">Žádné vypracované formuláře.</p>

            <v-divider class="my-4"></v-divider>

            <h4>
              <v-icon class="mr-2">mdi-file-multiple</v-icon>
              Soubory:
            </h4>
            <v-list v-if="selectedUser && selectedUser.filenames && selectedUser.filenames.length > 0" class="dense">
              <v-list-item v-for="(filename, index) in selectedUser.filenames" :key="index">
                <v-list-item-icon>
                  <v-icon>mdi-file-pdf</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <a :href="`https://cdn-sport.benatky.app/storage/pdf/${filename}`" target="_blank" class="text-decoration-none">
                    {{ filename }}
                  </a>
                </v-list-item-content>
              </v-list-item>
              
            </v-list>
            
            <p v-else class="text-muted">Žádné nahrané soubory.</p>
          </v-card-text>
        </v-card>
        
      </v-dialog>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="2000">
        {{ snackbar.text }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import Unlock from './Unlock.vue';
import { baseURL } from '@/Baseurl';

export default {
  components: {
    Unlock
  },
  data() {
    return {
      token: '',
      users: [],
      headers: [
        { title: 'Jméno', value: 'displayName' },
        { title: 'E-mail', value: 'email' },
        { title: 'Registrován', value: 'created_at' },
        { title: 'Role', value: 'status' },
        { title: 'Detail', value: 'action', sortable: false }
      ],
      loading: true,
      isdarkmode: localStorage.getItem('isDarkMode') === 'true',
      selectedUser: null,
      dialog: false,
      isAdmin: localStorage.getItem('is_admin') === '1',
      search: '',
      snackbar: { show: false, text: '', color: '' }
    };
  },
  mounted() {
    this.token = localStorage.getItem('jwt_token');
    if (!this.isAdmin) {
      this.$router.push('/nastenka');
    } else {
      this.fetchUsers();
    }
  },
  methods: {
    selectUser(user) {
      this.selectedUser = user;
      this.dialog = true;
    },
    async fetchUsers() {
      try {
        const response = await axios.get(`${baseURL}/api/users`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });
        this.users = response.data.map(user => ({
          ...user,
          uid: user.uid
        }));
      } catch (error) {
        console.error('Chyba při načítání uživatelů:', error);
        this.snackbar.show = true;
        this.snackbar.text = 'Chyba při načítání dat.';
        this.snackbar.color = 'error';
      } finally {
        this.loading = false;
      }
    },
     handleUnlock({ noticeboardId, updatedData }) {
      const noticeboard = this.selectedUser.noticeboards.find(n => n.id === noticeboardId);
      if (noticeboard) {
        noticeboard.isfinal = updatedData.isfinal;
        this.snackbar.show = true;
        this.snackbar.text = 'Formulář odemčen.';
        this.snackbar.color = 'success';
      }
    }
  }
};
</script>

<style scoped>
.mt-4-card {
  margin-top: 2rem;
}
</style>
